<template>
    <div class="layout-donate-result-share">
        <!-- 1、提示内容 -->
        <div class="donate-result-note">
            <p>您的捐赠已收到，非常感谢！</p>
            <p>已为您的木火八字账号点亮文化大使身份！</p>
            <p>马上转发到朋友圈或微信群吧！</p>
        </div>
        <!-- 2、图片绘制canvas部分 -->
        <div v-if="!showResultPic" class="donate-result-capture-box">
            <div ref="capture" class="donate-result-image-box">
                <img class="donate-result-image" v-bind:src="picUrl" alt="">
                <div class="donate-result-content">
                    <p>助力传统文化复兴，</p>
                    <p>我来加油！</p>
                    <p>我是第<span class="donate-result-number">{{myNum}}</span>位文化复兴大使！</p>
                </div>

                <div class="donate-result-info-box">
                    <div class="donate-result-info clearfix">
                        <div class="donate-result-info-left">
                            <img class="donate-result-info-avatar" v-bind:src="avatarUrl" alt="">
                            <p class="donate-result-info-nickname">{{nickName}}</p>
                        </div>
                        <div class="donate-result-info-right">
                            <qrcode class="donate-result-info-qrcode" id='qrImg' tag="img" :options="{size: 100, padding: 0}" :value="shareUrl" ></qrcode>
                            <div class="donate-result-info-note">
                                <p>长按识别二维码</p>
                                <p>成为易学复兴文化大使</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 3、截屏的图片部分 -->
        <div v-else class="donate-result-pic-box"></div>
        <div class="donate-result-sub-note"><span>长按图片保存到相册</span></div>
        <!-- 4、底部跳转链接 -->
        <div class="donate-result-link-paragraph" @click="clickCollate">
            <p>天时子平八字</p>
        </div>
    </div>
</template>

<script>
import html2canvas from 'html2canvas'
import { Canvas2Image } from '../../modules/canvas/canvas2image'
import { DOM } from '../../modules/dom';
export default {
    name: 'DonateResultShare',
    computed: {
        myNum() {
            return this.$store.state.donate.myNum;
        },
    },
    data() {
        return {
            picUrl: require('../../assets/images/donate-share-pic.png'),
            avatarUrl: require('../../assets/images/avatar.png'),
            nickName: '荷兰豆',
            shareUrl: '',
            showResultPic: false,
            saveImgSrc: ''
        }
    },
    mounted() {
        console.log('DonateResultShare-----mounted', Canvas2Image)
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            var captureDiv = document.getElementsByClassName('donate-result-capture-box')[0],
                imageDiv = document.getElementsByClassName('donate-result-image-box')[0];
                captureDiv.style.height = (innerHeight * 0.75) + 'px';

            // 初始化分享url
            this.shareUrl = 'https://' + window.location.hostname + '/donate';

            // 初始化头像
            var me = this,
                userInfo = this.$store.state.userData,
                nickname = userInfo && userInfo.info && userInfo.info.nickname ? userInfo.info.nickname : '某某某',
                avatar = userInfo && userInfo.info && userInfo.info.avatar ? userInfo.info.avatar : this.avatarUrl;
            console.log('初始化分享页面--------', userInfo, nickname, avatar);
            this.nickName = nickname;
            // 获取微信头像
            this.getBase64(avatar).then(function(result) {
                me.avatarUrl = result;
                setTimeout(() => {
                    // 直接绘制图片
                    me.getHtmlToCanvas();
                }, 20);
            });
        },
        getBase64(url, outputFormat = 'image/png') {
            /** 获取base64的图片 */
            return new Promise(function (resolve, reject) {
                var img = new Image,
                    canvas = document.createElement("canvas"),
                    ctx = canvas.getContext("2d");
                img.crossOrigin = "Anonymous";
                img.onload = function() {
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage( img, 0, 0 );
                    var dataURL = canvas.toDataURL(outputFormat);
                    canvas = null;
                    resolve(dataURL);
                }
                img.src = url;
                //  确保缓存的图片也触发 load 事件
                if ( img.complete || img.complete === undefined ) {
                    img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
                    img.src = url;
                }
            }).catch((err) => {
                console.error("error::::::", err);
            });
        },
        getHtmlToCanvas() {
            var me = this,
                captureDiv = this.$refs.capture,
                width = captureDiv.offsetWidth, //获取dom 宽度
                height = captureDiv.offsetHeight; //获取dom 高度
            var canvas = document.createElement("canvas"); //创建一个canvas节点
            var scale = 2;    //定义任意放大倍数 支持小数 1.065
                canvas.width = width * scale; //定义canvas 宽度 * 缩放
                canvas.height = height * scale; //定义canvas高度 *缩放
                canvas.getContext("2d").scale(scale, scale); //获取context,设置scale 
            var opts = {
                allowTaint: true,
                taintTest: false,
                scale: scale,      // 添加的scale 参数
                canvas: canvas,    //自定义 canvas
                // logging: true,  //日志开关，便于查看html2canvas的内部执行流程
                width: width,      //dom 原始宽度
                height: height,
                useCORS: true,     // 【重要】开启跨域配置
                dpi: window.devicePixelRatio, //window.devicePixelRatio是设备像素比
            };
            html2canvas(captureDiv, opts).then(canvas => { 
                me.showResultPic = true;
                var context = canvas.getContext('2d');
                // 【重要】关闭抗锯齿
                context.mozImageSmoothingEnabled = false;
                context.webkitImageSmoothingEnabled = false;
                context.msImageSmoothingEnabled = false;
                context.imageSmoothingEnabled = false;
                // 【重要】默认转化的格式为png,也可设置为其他格式
                var img = Canvas2Image.convertToPNG(canvas, canvas.width, canvas.height);
                // console.log('保存图片---------', img, canvas.width, canvas.height)
                setTimeout(() => {
                    var resultImage = document.getElementsByClassName('donate-result-pic-box')[0];
                    resultImage.innerHTML = '';
                    resultImage.appendChild(img);
                    var ratio = parseFloat(canvas.width / canvas.height);
                    // console.log('--------', canvas.width, canvas.height, ratio, resultImage.clientHeight)

                    var aW, aH;
                        aH = resultImage.clientHeight; aW = resultImage.clientHeight * ratio;
                    if(aW > resultImage.clientWidth) {
                        aW = resultImage.clientWidth; aH = resultImage.clientWidth / ratio;
                    }
                    // console.log('aaaaaaa-----', aW, aH)
                    img.style.width = aW + 'px';
                    img.style.height = aH + 'px';
                    if(resultImage.clientHeight > aH) {
                        img.style.marginTop = ((resultImage.clientHeight - aH) / 2) + 'px';
                    }
                }, 0);
            });
        },
        clickCollate() {
            DOM.resetStopTouch();
            this.$router.replace('/collate');
        }
    }
}
</script>